import { render } from "./WelcomeTile.vue?vue&type=template&id=9b48668e"
import script from "./WelcomeTile.vue?vue&type=script&lang=js"
export * from "./WelcomeTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__